import React from 'react';
import { Typography, Divider, Box, List, ListItem, ListItemText } from '@mui/material';

const InstructionSection: React.FC = () => {

  return (
    <Box sx={{ paddingTop: 3, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, textAlign: 'left' }}>
      {/* Titre avec ligne séparatrice */}
      <Typography variant="h5" component="h1" sx={{ marginBottom: '4px', color: '#1b65ac', marginLeft: '170px' }}>
        Votre recherche
      </Typography>

      <Divider sx={{ backgroundColor: '#1b65ac', height: '2px', margin: '8px auto', width: '80%', marginLeft: '170px' }} />

      {/* Instruction utilisateur */}
      <Typography variant="body2" sx={{ margin: '0', marginLeft: '170px' }}>
        Vous pouvez effectuer la recherche d'un particulier en renseignant :
      </Typography>

      {/* Liste avec puces pour les conditions */}
      <List sx={{ paddingLeft: '170px', paddingTop: '0', paddingBottom: 0, paddingRight: 0 }}>
        <ListItem sx={{ padding: '0' }}>
          <ListItemText primary="- soit son numéro CSF," />
        </ListItem>
        <ListItem sx={{ padding: '0' }}>
          <ListItemText primary="- soit ses nom, prénom et date de naissance." />
        </ListItem>
      </List>
    </Box>
  );
};

export default InstructionSection;
